import { render, staticRenderFns } from "./BuildLab.vue?vue&type=template&id=b615d606&scoped=true&"
import script from "./BuildLab.vue?vue&type=script&lang=js&"
export * from "./BuildLab.vue?vue&type=script&lang=js&"
import style0 from "./BuildLab.vue?vue&type=style&index=0&id=b615d606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b615d606",
  null
  
)

export default component.exports